import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class RelationSearchModel extends BaseModel {
  related_customer_uuid = null;
  type = null;

  rules = {};

  attributeLabels = {
    related_customer_uuid: i18n.t('Customer'),
    type: i18n.t('Type')
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    delete data.related_customer;

    return data;
  }
}
